import { motion } from 'framer-motion';
import styled from 'styled-components';

export const StyledButton = styled(motion.button)<any>`
  background: #e02f29;
  box-shadow: 0px 4px 4px #000000;
  border-radius: 80px;
  padding: 7px 20px;
  font-family: 'Graduate';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 155.1%;
  text-align: center;
  -webkit-letter-spacing: 0.12em;
  -moz-letter-spacing: 0.12em;
  -ms-letter-spacing: 0.12em;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #ffffff;
  cursor: pointer;
  border: 0.5px solid #e02f29;

  &:hover,
  &:active,
  &:focus {
    border: 0.5px solid #fff !important;
  }
`;
